export const handleSortClick = (sortBy: string, value: string) => {
	let sortValue = '';
	if (sortBy === value) {
		sortValue = '';
	} else {
		sortValue = value;
	}
	return sortValue;
};
